/**
 * Mutual-room slug helpers.
 *
 * A mutual room's slug is `m-<base32(ownerDid)>`. The worker decodes the owner
 * from this slug and admits only the owner or the owner's mutuals. The encoder
 * lives in slugCodec.ts and MUST stay byte-identical to the worker's
 * src/social/mutualSlug.js.
 */

import {encodeDidBase32} from './slugCodec'

const PREFIX = 'm-'

/**
 * Encodes an owner DID into its mutual-room slug.
 */
export function ownerDidToSlug(did: string): string {
  return PREFIX + encodeDidBase32(did)
}

/**
 * The current user's own mutual-room slug (the room the sticky Cam button opens).
 */
export function myMutualRoomSlug(myDid: string): string {
  return ownerDidToSlug(myDid)
}

/** True if a slug is a mutual room (vs an open/ad-hoc room). */
export function isMutualRoomSlug(slug: string): boolean {
  return slug.startsWith(PREFIX)
}
